<div *ngIf="medicalHistoryRequestForm; else profile" class="request-container">
  <mat-card class="request-card" *ngIf="medicalHistoryRequestForm.doctorName">
    <mat-card-header>
      <mat-card-title>{{ 'medical_history' | translate }}</mat-card-title>
      <mat-card-subtitle *ngIf="medicalHistoryRequestForm.doctorName">From {{ medicalHistoryRequestForm.doctorName }}</mat-card-subtitle>
      <img mat-card-avatar *ngIf="medicalHistoryRequestForm.doctorLogo" [src]="medicalHistoryRequestForm.doctorLogo" />
    </mat-card-header>
    <mat-card-content *ngIf="medicalHistoryRequestForm.respondedOn">
      <div class="responded-card">
        <h4>{{ 'responded_on_colon' | translate }}</h4>
        <span>{{ medicalHistoryRequestForm.respondedOn | customDate: 'T DDDD ZZ' }}</span>
      </div>
      <div class="responded-card">
        <h4>{{ 'response_result_colon' | translate }}</h4>
        <span>
          <div class="accepted">
            <mat-icon
              [color]="medicalHistoryRequestForm.accepted ? 'primary' : 'warn'"
              [svgIcon]="medicalHistoryRequestForm.accepted ? 'check-circle' : 'close-circle'"
            ></mat-icon>
            <span>
              {{ medicalHistoryRequestForm.accepted ? ('accepted' | translate) : ('declined' | translate) }}
            </span>
          </div>
        </span>
      </div>
    </mat-card-content>
  </mat-card>
  <button mat-stroked-button color="primary" (click)="getDataFromProfile()" [disabled]="medicalHistoryRequestForm.complete">
    <mat-icon>content_copy</mat-icon>
    {{ 'copy_from_profile' | translate }}
  </button>
  <div class="content">
    <div class="medical-history">
      <ng-container *ngTemplateOutlet="medicalHistoryTemplate; context: { medicalHistory: medicalHistoryRequestForm }"></ng-container>
    </div>
    <div [class.disabled]="medicalHistoryRequestForm.respondedOn" class="text-center">
      <mat-checkbox #saveToProfile>
        <span class="save-to-profile">
          <span>
            {{ 'overwrite_current_account_with' | translate }}
            <br />
            <i>{{ 'patient_details' | translate }}</i>
          </span>

          <mat-icon class="icon" matTooltipPosition="above" matTooltipClass="tooltip-warning" svgIcon="alert-circle-outline"></mat-icon>
        </span>
      </mat-checkbox>
      <button mat-raised-button type="submit" class="submit-button" (click)="submitMedicalHistory()">
        {{ 'submit_medical_history_progress' | translate: { answered: amountQuestions, total: tabLabels.length } }}
      </button>
    </div>
  </div>
</div>
<ng-template #profile>
  <div *ngIf="user$ | async as user">
    <gc-breadcrumb-bar class="header" [crumbs]="[user.name, 'medical_history' | translate]"></gc-breadcrumb-bar>
    <div *ngIf="medicalHistory$ | async as medicalHistory" class="profile-container">
      <ng-container *ngTemplateOutlet="medicalHistoryTemplate; context: { medicalHistory: medicalHistory }"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #medicalHistoryTemplate let-medicalHistory="medicalHistory">
  <div class="content">
    <mat-card class="medical-history">
      <mat-tab-group
        [disablePagination]="isMobile$ | async"
        mat-stretch-tabs
        class="history-tab-group custom-tab-group text-white shadow rounded-top"
        mat-align-tabs="center"
        backgroundColor="primary"
        (selectedTabChange)="tabChange($event)"
        [(selectedIndex)]="selectedIndexBinding"
        #tabGroup
      >
        <div *ngIf="(isMobile$ | async) === false; else mobileView">
          <mat-tab *ngFor="let tab of tabLabels; let index = index" [label]="tab.label | translate">
            <div *ngIf="tab.label === tabLabel">
              <ng-container *ngTemplateOutlet="medicalHistoryTabs; context: { medicalHistory: medicalHistory }"></ng-container>
            </div>
          </mat-tab>
        </div>
        <ng-template #mobileView>
          <mat-tab [label]="tabLabel">
            <ng-template mat-tab-label>
              <span class="custom-tab-label">
                <mat-icon class="tab-icon pr-3" (click)="scrollTab(-1, tabLabel)">chevron_left</mat-icon>
                <div>{{ tabLabelName(tabLabel) | translate }}</div>
                <mat-icon class="tab-icon pr-3" (click)="scrollTab(1, tabLabel)">chevron_right</mat-icon>
              </span>
            </ng-template>
            <ng-container *ngTemplateOutlet="medicalHistoryTabs; context: { medicalHistory: medicalHistory }"></ng-container>
          </mat-tab>
        </ng-template>
      </mat-tab-group>
    </mat-card>
  </div>
</ng-template>

<!-- A switch statement of all the medical history components -->
<!-- If a requestUuid is given 'submit' will save to the request -->
<!-- If userId is given 'submit' will save to the user -->
<!-- submittedStep keeps track what has been saved -->
<ng-template #medicalHistoryTabs let-form="medicalHistory">
  @switch (tabLabel) {
    @case ('generalHealth') {
      <gc-general-health
        [requestUuid]="form.uuid"
        [userId]="userId"
        [generalHistory]="form.generalHealth"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-general-health>
    }
    @case ('familyHistory') {
      <gc-family-history
        [userId]="userId"
        [requestUuid]="form.uuid"
        [familyHistory]="form.familyHistory"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-family-history>
    }
    @case ('allergies') {
      <gc-allergies
        [userId]="userId"
        [requestUuid]="form.uuid"
        [allergiesData]="form.allergies"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-allergies>
    }
    @case ('chronicItems') {
      <gc-chronic
        [userId]="userId"
        [requestUuid]="form.uuid"
        [chronicData]="form.chronicItems"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-chronic>
    }
    @case ('operationHistory') {
      <gc-operation-history
        [userId]="userId"
        [requestUuid]="form.uuid"
        [operationHistory]="form.operationHistory"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-operation-history>
    }
    @case ('treatmentHistory') {
      <gc-treatment-history
        [userId]="userId"
        [requestUuid]="form.uuid"
        [treatmentHistory]="form.treatmentHistory"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-treatment-history>
    }
    @case ('occupationalAndDemographicalHistory') {
      <gc-occupation-history
        [userId]="userId"
        [requestUuid]="form.uuid"
        [occupationalAndDemographicalHistoryData]="form.occupationalAndDemographicalHistory"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-occupation-history>
    }
    @case ('vaccinations') {
      <gc-vaccinations
        [userId]="userId"
        [requestUuid]="form.uuid"
        [vaccinationsData]="form.vaccinations"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-vaccinations>
    }
    @case ('travelHistory') {
      <gc-travel-history
        [userId]="userId"
        [requestUuid]="form.uuid"
        [travelHistory]="form.travelHistory"
        (submittedStep)="submittedStep($event)"
        [class.disabled]="form.respondedOn"
      ></gc-travel-history>
    }
  }
</ng-template>
